import { Trans, useTranslation } from "react-i18next";
import Button from "../Button";

const Package = () => {
    const { t } = useTranslation();
    return (
        <section className="relative mt-[90px] md:mt-0 open-sans bg-[#15318D]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] md:py-[80px] py-[40px]">
                <div className="md:grid flex flex-col grid-cols-2 gap-[0] md:gap-[40px] xl:gap-[95px] sm:text-[16px] text-[14px] text-[#fff] font-[300]">
                    <div>
                        <h2 className="open-sans text-[#FFF] font-[700] text-[28px] xl:text-[45px] text-center md:text-left">
                            <Trans>
                                {t('premium.package.title')}
                            </Trans>
                        </h2>
                        <p className="font-[700] open-sans sm:text-[16px] text-[14px] text-[#fff] mt-[15px] text-center md:text-left">
                            {t('premium.package.subtitle')}
                        </p>
                        <Button className="mt-[40px] hidden md:flex" color="#EFEFEF" text="#0C2780" />
                    </div>
                    <ul className="flex flex-col sm:gap-[15px] gap-[10px] list-outside list-disc sm:pl-[25px] pl-[20px] font-[300] open-sans sm:text-[16px] text-[14px] text-[#fff] md:mt-[0] mt-[30px]">
                        <li>{t('premium.package.li_01')}</li>
                        <li>{t('premium.package.li_02')}</li>
                        <li>{t('premium.package.li_03')}</li>
                        <li>{t('premium.package.li_04')}</li>
                        <li>{t('premium.package.li_05')}</li>
                    </ul>
                    <Button className="mt-[40px] flex md:hidden" color="#EFEFEF" text="#0C2780" />
                </div>
            </div>
        </section>
    )
};

export default Package;
